<template>
	<div class="fullWidth logo center" id="report">
		<loading v-if="loadingState" />

		 <div class="constainer-fluid dataContainer ">

			<div class="row justify-content-center ">


				<h1 class="Peace center violet widthFull">Prodotti Caricati</h1>

				<div class="col-12 col-md-9"></div>
				<div class="col-12 col-md-3">
	        <form
	          class="form-inline d-flex mx-1 justify-content-end"
	          @submit.stop.prevent="doSearch"
	        >
	          <div class="input-group">
	            <input
	              v-model="quickSearch"
	              type="search"
	              placeholder="Cerca"
	              class="form-control"
	            >
	            <div class="input-group-append">
	              <button
	                type="submit"
	                class="btn btn-outline-secondary"
	              >
	                <i class="mdi mdi-magnify" /> Go
	              </button>
	            </div>
	          </div>
	        </form>
	      </div>
	    </div>
	    <!-- Using the VdtnetTable component -->
	    <vdtnet-table
	      ref="table"
	      :fields="fields"
				:url="url"
	      :opts="options"
	      :select-checkbox="0"
	      container-classname=""
	      @edit="doAlertEdit"
	      @reloaded="doAfterReload"
	      @table-creating="doCreating"
	      @table-created="doCreated"
	    >
	    </vdtnet-table>
	   </div>
		</div>


	</div>

</template>


<script>
  import { mapGetters, mapState } from 'vuex'
  import axios from 'axios'
	import store from '../../store'

  //import Datepicker from 'vuejs-datepicker'
  //import {it} from 'vuejs-datepicker/dist/locale'
  //import VueTimepicker from 'vue2-timepicker'

	import VdtnetTable from '../table/productsTable.vue'

	import 'datatables.net-bs4'
	// import buttons and plugins
  import 'datatables.net-buttons/js/dataTables.buttons.js'
  import 'datatables.net-buttons/js/buttons.html5.js'
  import 'datatables.net-buttons/js/buttons.print.js'
  // import the rest
  import 'datatables.net-buttons-bs4'
  import 'datatables.net-select-bs4'
  import 'datatables.net-select-bs4/css/select.bootstrap4.min.css'
  import 'datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css'
	import Swal from 'sweetalert2'

  const moment = require('moment')

	const _vue = this

  export default {
    name: 'users',
		components: {
			//Datepicker,
			//VueTimepicker,
			VdtnetTable
		},
		//props: ["fields"],
		data () {
			//const vm = this
			//const compiler = require('vue-template-compiler')
      return {
				loadingState: false,
				loaded: false,
				userToken: '',
				company: '',
				//username: '',
				//it: it,
				eventName: '',
				objectMail: '',
				sms: '',
				smsSender: '',
				json: {},
				textMail: '',
				eventDescription: '',
				_vue: this,
				//role: '',
				nome: '',
				password: '',
				active: 0,
				id: 0,
				rows: {},
				url: process.env.ROOT_API + 'api/loadProducts?id=' + this.$route.params.id,
        routeParam: this.$route.params.id,
      	options: {
        	ajax: {
          	url: process.env.ROOT_API + 'api/loadProducts?id=' + this.$route.params.id,
						headers: {
				      'Authorization': 'Bearer '+ process.env.AUTH_TOKEN,
							'Content-type': 'application/json'
				    },
						type: 'GET',
          	dataSrc: (json) => {
							//this.buildFields(json)
              if ( this.$route.params.id ){
                return json.data
              }else{
                return false
              }

          	}
        	},
        	buttons: [
						//'copy',
						//'print',
						//{
						//	 text: 'CSV',
						//	 extend: 'csv',
						//	 fieldSeparator: ';',
						//	 extension: '.csv'
					 // }
					 //{
					//	 text: 'Aggiungi utente',
					//	 action: function ( e, dt, node, config ) {
					//	  	_vue.a.methods.addUser( _vue.a, dt )
					//   }

					 //},

					],
					/*eslint-disable */
        	dom: "Btr<'row vdtnet-footer'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'pl>>",
					/*eslint-enable */
        	responsive: true,
        	processing: true,
        	searching: true,
        	searchDelay: 1500,
        	destroy: true,
        	ordering: true,
        	lengthChange: true,
        	serverSide: true,
        	fixedHeader: true,
        	saveState: true
      	},
				fields: {
					confirmed: {
						label: 'Esito',
						sortable: true,
						searchable: true,
						render: (data, display ,row) => {

							if ( data == 0 ){
								return ' In Verifica '
							}

							if ( data == 1 ){
							 return ' Approvato '
							}

							 if ( data == 2 ){
								return ' Respinto <br/> <small> ' +row.confirm_info+ '</small>'
							 }

							 if ( data == 3 ){
								 if ( row.confirm_info == 'finish' ){
									 return ' Documentazione non verificata per soglia premi/agenzia raggiunta '
								 }
								 if ( row.confirm_info == 'finish_award' ){
									 return ' Documentazione non verificata - obiettivo raggiunto '
								 }

							 }


						}
					},
					credits: {
						label: 'Valore',
						sortable: true,
						searchable: true,
						render: (data, display ,row) => {

							if ( data == 1 ){
								return ' 25% del premio '
							}

							if ( data == 2 ){
							 return ' 50% del premio '
							}

						}
					},
					azienda: { label: 'Azienda', sortable: true, searchable: true },
 				  partita_iva: { label: 'Partita IVA', sortable: true, searchable: true },
 				  codice_fiscale: { label: 'Codice Fiscale', sortable: true, searchable: true },

					barcode: {
            label: 'Matricola',
            sortable: true,
            searchable: true,
            render: (data, display ,row) => {
              return ' <a class="simpleLink green" target="_blank" href="'+ row.image +'"> <small>'+ data +'</small> </a> '
            }
          },
         product: { label: 'Prodotto', sortable: true, searchable: true },

				 invoice_number: {
					 label: 'Prova d`acquisto',
				   sortable: true,
					 searchable: true,
					 render: (data, display ,row) => {
						 return ' <a class="simpleLink green" target="_blank" href="'+ row.invoice +'"> <small>'+ data +'</small> </a> '
					 }
				 },



         invoice_date: { label: 'Data Doc.', sortable: true, searchable: true },




       },
      quickSearch: '',
      details: {},
			customTheme: {
				logo: "https://storage.googleapis.com/novatagstage/logo_custom.png",
				background: "https://storage.googleapis.com/novatagstage/custom_background.jpg",
				textColor: "#fff",
				windowColor: "#000000e0"
			},
			}
    },
    methods: {
			doLoadTable(cb) {
	    },
	    doAlertEdit(data) {
	      window.alert(`row edit click for item ID: ${data.id}`)
	    },
	    doAfterReload(data, table) {
	    },
	    doCreating(comp, el) {
	    },
	    doCreated(comp) {
	    },
	    doSearch() {
	      this.$refs.table.search(this.quickSearch)
	    },
	    doExport(type) {
	      const parms = this.$refs.table.getServerParams()
	      parms.export = type
	      window.alert('GET /api/v1/export?' + jQuery.param(parms))
	    },
	    formatCode(zipcode) {
	      return zipcode.split('-')[0]
	    },
			loadRegistrationData(){
				var _vue = this
				var fields = {}

				var data = { getFieldsNames: true }

				_vue.loadingState = true
				axios({
					url: process.env.ROOT_API + 'api/loadProducts?id=' + this.$route.params.id,
					method: 'POST',
					headers: {'Authorization': 'Bearer '+ process.env.AUTH_TOKEN, 'Content-type': 'application/json'},
					data: data,
				})
				.then(resp => {
					_vue.loadingState = false
					_vue.rows = resp.data
					//this.$log(_vue.rows)
					for ( var x in _vue.rows ){
							fields[_vue.rows[x].  db] = { label: ''+_vue.rows[x].db+''  }
					}
					//this.$log(fields)
					_vue.fields = fields
					const table = _vue.$refs.table
					this.$log(	table )
					//table.dataTable.destroy()
					//table.dataTable.fields = fields
					table.dataTable.init()
					table.dataTable.draw(false)
					table.dataTable.columns.adjust()
					table.reload()

				})
				.catch(resp => {
					_vue.loadingState = false
					this.$log(resp)
				})



			},

    },
		watch: {
			'$route.params.id': {
        handler: function(id) {
           this.$log(id)
					 if ( this.loaded ){
						 //window.location.reload()
					 }
        },
        deep: true,
        immediate: true
      },
			getProfile: function(){
				var _vue = this
				_vue.id = _vue.$route.params.id
				setTimeout(function(){
          _vue.id = _vue.$route.params.id
					_vue.loaded = true
				},1000)

			}
		},
		async created(){
      if ( this.$route.params.id ){
        await this.loadRegistrationData()
      }else{
        this.$router.push('/')
      }

		},

		mounted: async function(){
			var _vue = this
			this.id = this.$route.params.id

      if ( this.$route.params.id ){
        await this.loadRegistrationData()
      }else{
        this.$router.push('/')
      }

			setTimeout(function(){
				_vue.loaded = true
			},1000)

			window.onresize = () => {
					this.vw = window.innerWidth
			}

		},
		computed: {
	      ...mapGetters(['tappa','isAuthenticated', 'authStatus', 'tappa', 'getProfile']),
				...mapState({
					authLoading: state => state.auth.status === 'loading',
					profile: state => state.user.profile
				})
	    },
 }
</script>

<style lang="css" scoped>

	.table-striped {
		overflow-x: auto;
		display: table;
		max-height: 63vh;
	}

	.priceVal, .priceCent{
		width: calc(50% - 1.5vw - 7.5px);
		display: inline-grid;
	}

	.pseudoEuro {
		position: absolute;
		top: 6px;

	}
	.pseudoCent {
		position: absolute;
		top: 6px;
		right:0;

	}

	.group input:focus + .pseudoEuro {
		display:block;
	}

	.group .valid + .pseudoEuro{
		display:block;
	}

	.group input:focus + .pseudoCent {
		display:block;
	}

	.group .valid + .pseudoCent{
		display:block;
	}

	.euroInput{
		position: relative;
		width:200%;
		z-index: 4;
	}

	.euroInput::before{
		content: 'Euro';
	}

	.euroInput:focus, .euroInput.valid{
		width:100%;
	}

	.euroInput:focus::before, .euroInput.valid::before{
		content: 'Euro';
		color: #2b773c;
		position: absolute;
	}

	.table{
		display: table;
	}

	.priceVal{

	}

	.priceCent{

	}

	.labelFileInput{
		top: -20px;
		font-size: 14px;
		color: #d3a399;
	}

	.fileInput{
		position: absolute;
		z-index: 1;
		width: 100%;
		height: 100%;
		padding: 0;
		top: 4px;
		border-bottom: none;
		color: #000000;
	}

	.fileInputLabel{
		z-index: 3;
		white-space: nowrap;
		overflow: hidden;
		padding-right: 20px;
		text-overflow: ellipsis;
		color: #fffbde;
	}

	.newPriceLabel{
		z-index: 5;
		background: #fcfcfc;
		margin-left: -5px;
		padding-left: 5px;
		overflow: initial;
		min-width: calc(200% + 17px);
	}

	.formHeader {
		font-size: 18px;
		background: #990033!important;
		width: 100%;
		color: #ffffff!important;
		text-transform: uppercase;
		font-family: CoreRhino75Heavy;
	}

	.greyDesc{
		font-size: 3vw;
	}
	img.playVideoButton {
		max-width: 200px;
		cursor: pointer;
	}
	.zindex1{
		z-index: 1;
	}
	.maxCertificate{
		max-width: 130px;
	}
	.reflection{
		position: absolute;
		width: 20vw;
		height: 19vw;
		top: -3%;
		right: 0%;
		border-radius: 50%;
		background: radial-gradient(#ffffff59,#e7798985,#eee0,#eee0);
		z-index: 0;
	}
	.relative{
		position: relative;
	}

	.cup4Shadow{
		position: absolute;
		height: 40px;
		background: radial-gradient(#0e0e0ee0,#000000e3, #ffffff00, #f9f9f900);
		border-radius: 50%;
		width: 50%;
		right: 19%;
		bottom: 37.4%;
		z-index: 0;
	}
	.cup1Shadow {
		position: absolute;
		height: 57px;
		background: radial-gradient(#0e0e0ec4,#ffc80024, #00000000, #38383845);
		border-radius: 50%;
		width: 67%;
		right: 24%;
		bottom: 35%;
		z-index: 1;
	}
	@media (min-width: 20px) and (max-width: 767px) {
		.greyDesc{
			text-align: center;
			font-size: 4vw;
		}
		img.playVideoButton {
			position: relative!important;
			top: 0!important;
			margin-top: 20px;
		}
		.maxCertificate{
			max-width: 100px;
		}

		.reflection {
			width: 73vw;
			height: 64vw;
		}

		.cup4Shadow{
			height: 57px;
			width: 50vw;
			right: 18%;
			bottom: 36.4%;
		}
		.cup1Shadow {
			height: 74px;
			width: 80%;
			right: 10%;
			bottom: 35%;
		}

	}


</style>



// WEBPACK FOOTER //
// src/components/showProducts/index.vue